module.exports = __webpack_public_path__ + "img/ww_example_logo.a5968bd7.png";